import { Component } from 'components/users-and-access';

/** @ngInject */
export default function usersAndAccessRouter($stateProvider) {
    const baseState = {
        redirectTo: 'main.users-and-access.users',
        views: {
            content: {
                component: Component.selector
            }
        }
    };

    $stateProvider
        .state('main.users-and-access', baseState);
}



// WEBPACK FOOTER //
// ./app/components/users-and-access/users-and-access.router.js